import React from "react"
import { useTheme } from "@material-ui/core"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import JobSummary from "../common/JobSummaryChart"

const OverallCountSummaryView = () => {
	const [t] = useTranslation("global")
	const caseDetails = useSelector((state) => state.bifrostCaseDetails.caseDetails)
	const isPageLoading = useSelector((state) => state.bifrostCaseDetails.isLoading)

	const theme = useTheme()

	const getChartData = () => {
		const chartData = [
			["Job type", "count", { role: "style" }],
			[t("bifrost.charts.upload"), caseDetails?.files_summary?.uploaded_files.count, theme.palette.barGraph.B40],
			[t("bifrost.charts.extract"), caseDetails?.files_summary?.text_extracted_files.count, theme.palette.barGraph.B40],
			[t("bifrost.charts.extractNames"), caseDetails?.files_summary?.pii_extracted_files.count, theme.palette.barGraph.B40],
			// [t("bifrost.charts.kbMaking"), caseDetails?.files_summary?.kb_files.count, theme.palette.barGraph.B40],
		]
		return chartData
	}
	return (
		<JobSummary
			data={getChartData()}
			loading={isPageLoading}
			title={t("bifrost.titles.overallCount")}
			legends={[{ text: t("bifrost.charts.jobTypes"), color: theme.palette.barGraph.B40 }]}
			barWidth={`${(50 * getChartData().length) / 10}%`}
			axisTitle={{ x: t("bifrost.charts.jobTypes"), y: t("bifrost.charts.counts") }}
		/>
	)
}

export default OverallCountSummaryView
